import { closeSnackbarNotificationReducer } from '@slices/snackbar-notification/close-snackbar-notification';
import { enqueueSnackbarNotificationReducer } from '@slices/snackbar-notification/enqueue-snackbar-notification';
import { removeSnackbarNotificationReducer } from '@slices/snackbar-notification/remove-snackbar-notification';

import { appCreateSlice } from '@store/rtk';

import { SnackbarNotificationState } from './types';

export const snackbarNotificationDefaultState: SnackbarNotificationState = {
  notifications: [],
};

export const snackbarNotificationSlice = appCreateSlice({
  name: 'snackbarNotification',
  initialState: snackbarNotificationDefaultState,
  reducers: {
    enqueueSnackbarNotification: enqueueSnackbarNotificationReducer,
    closeSnackbarNotification: closeSnackbarNotificationReducer,
    removeSnackbarNotification: removeSnackbarNotificationReducer,
  },
});

export const {
  actions: {
    enqueueSnackbarNotification,
    closeSnackbarNotification,
    removeSnackbarNotification,
  },
  reducer: snackbarNotificationReducer,
} = snackbarNotificationSlice;
